import { defineComponent as _defineComponent } from 'vue'
import { ref, reactive, onMounted } from 'vue';

import { DerivativesFilters } from './components/DerivativesFilters';
import { DerivativesTable } from './components/DerivativesTable';
import { HelperViewStatus } from '@warrenbrasil/nebraska-web';
import { Pagination } from '@/modules/common/components/Pagination';

import { isRequestError } from '@warrenbrasil/web-http';
import {
  IDerivativesFilters,
  DerivativesFiltersTypes,
  DerivativesFiltersTypeValues,
  DerivativesFiltersDateValues
} from './types';
import { PositionsDateFilterOptions, PositionsTypeFilterOptions } from './data';
import {
  getOptionsList,
  GetOptionsListResponse,
  OptionPosition,
  getHistoricalOptionsList,
  GetHistoricalOptionsListResponse,
  HistoricalOptionPosition,
  getForwardList,
  GetForwardListResponse,
  ForwardContractPosition
} from '@/modules/trade/services/instruments';


export default /*#__PURE__*/_defineComponent({
  __name: 'Derivatives',
  setup(__props) {

const items = ref<
  OptionPosition[] | ForwardContractPosition[] | HistoricalOptionPosition[]
>([]);
const isLoading = ref<boolean>(false);
const hasError = ref<boolean>(false);
const updatedAtMessage = ref<string>('');
const abortSignal = ref<AbortController | null>(null);
const pagination = ref({
  currentPage: 1,
  totalPages: 1,
  itemsPerPage: 10
});
const filters: IDerivativesFilters = reactive({
  [DerivativesFiltersTypes.Date]: {
    selected: DerivativesFiltersDateValues.Today,
    available: PositionsDateFilterOptions
  },
  [DerivativesFiltersTypes.Type]: {
    selected: DerivativesFiltersTypeValues.Options,
    available: PositionsTypeFilterOptions
  }
});

const servicesByFilter = {
  [DerivativesFiltersTypeValues.Options]: {
    [DerivativesFiltersDateValues.Today]: getOptionsList,
    [DerivativesFiltersDateValues.Historical]: getHistoricalOptionsList
  },
  [DerivativesFiltersTypeValues.Forwards]: {
    [DerivativesFiltersDateValues.Today]: getForwardList,
    [DerivativesFiltersDateValues.Historical]: () => {}
  }
};

const mountView = (
  data:
    | GetOptionsListResponse
    | GetForwardListResponse
    | GetHistoricalOptionsListResponse
    | void
) => {
  if (!data) return;
  const {
    updatedAt,
    items: derivativesItems,
    pagination: { itemsPerPage, totalPages, page }
  } = data;
  updatedAtMessage.value = updatedAt.formatted;
  items.value = derivativesItems;
  pagination.value = {
    totalPages,
    itemsPerPage,
    currentPage: page
  };
};

const getDerivativesData = async () => {
  try {
    isLoading.value = true;
    hasError.value = false;
    if (abortSignal.value) abortSignal.value.abort();
    abortSignal.value = new AbortController();

    const selectedType =
      filters[DerivativesFiltersTypes.Type].selected ||
      DerivativesFiltersTypeValues.Options;
    const selectedDate =
      filters[DerivativesFiltersTypes.Date].selected ||
      DerivativesFiltersDateValues.Today;

    const service = servicesByFilter[selectedType][selectedDate];

    const data = await service(
      {
        itemsPerPage: pagination.value.itemsPerPage,
        page: pagination.value.currentPage
      },
      abortSignal.value.signal
    );

    mountView(data);
  } catch (e) {
    if (isRequestError(e) && e.type === 'canceled') return;
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
};

const handleOnSelectFilter = (
  filterType: DerivativesFiltersTypes,
  filterValue: DerivativesFiltersTypeValues | DerivativesFiltersDateValues
) => {
  if (filterType === DerivativesFiltersTypes.Type) {
    filters[DerivativesFiltersTypes.Date].selected =
      DerivativesFiltersDateValues.Today;
  }
  filters[filterType].selected = filterValue;
  pagination.value.currentPage = 1;
  getDerivativesData();
};

const handleOnPageChange = (page: number) => {
  pagination.value.currentPage = page;
  getDerivativesData();
};
onMounted(() => getDerivativesData());

return { __sfc: true,items, isLoading, hasError, updatedAtMessage, abortSignal, pagination, filters, servicesByFilter, mountView, getDerivativesData, handleOnSelectFilter, handleOnPageChange, DerivativesFilters, DerivativesTable, HelperViewStatus, Pagination }
}

})